/* eslint-disable no-unused-vars */
import { Form, Input, InputNumber } from 'antd';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import DokanIcons from '../icon/DokanIcons';

function DokanPrexSufxInputTextField({
    styleClasses,
    disableMargin,
    placeholder,
    icon,
    FormInputName,
    FormInputLabel,
    FormInputRules,
    onValueChange,
    children,
}) {
    const [inputVal, setInputVal] = useState(null);
    // Handle Input....
    const changeInputField = (name, value) => {
        console.log('checkbox', name, value);
        onValueChange(name, value);
    };

    const getInputData = useSelector((state) => state.products.productInputData);
    const InputData = { ...getInputData };
    const setInputData = InputData[FormInputName];
    return (
        <>
            <Form.Item name={FormInputName} label={FormInputLabel} rules={FormInputRules}>
                <Input
                    className={`rounded-md ${styleClasses} ${!disableMargin && 'mt-20px'}`}
                    placeholder={placeholder}
                    size="small"
                    value={setInputData}
                    onChange={(e) => changeInputField(FormInputName, e.target.value)}
                    prefix={<DokanIcons icon={icon} size="8" styleClasses="#DEDEDE" />}
                />
            </Form.Item>
            {children}
        </>
    );
}

export default DokanPrexSufxInputTextField;
